const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error'
};

(() => {
  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  const blockedExact = new Set([
    'free shipping for all orders over $10.00',
    'free delivery worldwide',
    'summer sale! 50% off for boots!'
  ]);
  const countdownLabels = new Set(['days', 'hour', 'mins', 'secs']);
  const selector = 'p, small, li, section, aside, div, span';
  const pendingRoots = new Set();
  let flushQueued = false;

  function scanRoot(root) {
    if (!(root instanceof Element) || !root.isConnected) return;

    const countdownMatches = [];
    const inspect = (element) => {
      if (!element.isConnected) return;
      const text = normalize(element.textContent);

      if (blockedExact.has(text)) {
        element.remove();
        return;
      }

      if (countdownLabels.has(text)) countdownMatches.push(element);
    };

    if (root.matches(selector)) inspect(root);
    root.querySelectorAll(selector).forEach(inspect);

    if (countdownMatches.length < 4) return;

    for (const match of countdownMatches) {
      let container = match;
      while (container && container !== document.body) {
        const text = normalize(container.textContent);
        if (
          text.includes('days') &&
          text.includes('hour') &&
          text.includes('mins') &&
          text.includes('secs')
        ) {
          container.remove();
          return;
        }
        container = container.parentElement;
      }
    }
  }

  function flushPendingRoots() {
    flushQueued = false;
    for (const root of pendingRoots) scanRoot(root);
    pendingRoots.clear();
  }

  function queueRoot(root) {
    if (!(root instanceof Element)) return;
    pendingRoots.add(root);
    if (flushQueued) return;
    flushQueued = true;

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(flushPendingRoots, { timeout: 500 });
    } else {
      window.setTimeout(flushPendingRoots, 50);
    }
  }

  function cleanLegacyPromotions() {
    if (document.body) scanRoot(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanLegacyPromotions, { once: true });
  } else {
    cleanLegacyPromotions();
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) queueRoot(node);
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 30000);
})();
